import { initFacebookPixel } from '../../utils/facebookPixel';

function FacebookPixel(id) {
    if (!id) {
        console.error('Facebook Pixel ID is required');
        return;
    }

    try {
        // Just hook into the already-initialized pixel (server template fired
        // fbq('init') + fbq('track','PageView') in <head>). Don't call
        // fbPageView() here — it would double-count the initial view.
        // Header.js still fires fbPageView() on SPA route changes.
        initFacebookPixel(id, { autoConfig: true, debug: false });
    } catch (error) {
        console.error('Facebook Pixel initialization error:', error);
    }
}

export default FacebookPixel;
